import React, { useState, useMemo, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import CustomCheckboxFilter from "../../../utils/CustomCheckboxFilter";
// import StatusRenderer from "../../../utils/MatchStatusRender";
import MatchCustomButton from "../../../utils/MatchCustomButtonOperator";
import SearchFilter from "../../../utils/SearchFilter";
import MatchToggleButton from "../../../utils/MatchToggleButton";

ModuleRegistry.registerModules([AllCommunityModule]);

const MatchTable = ({ matchData, onEdit, onDelete, onAbandon, onJodiReport, getMatches }) => {
  const [rowData, setRowData] = useState([]);
  const [quickFilterText, setQuickFilterText] = useState("");

  useEffect(() => {
    setRowData(matchData);
  }, [matchData]);

  const handleQuickFilterChange = (e) => {
    setQuickFilterText(e.target.value);
  };

  const autoSizeStrategy = useMemo(() => ({ type: "fillGrid" }), []);

  const defaultColDef = useMemo(
    () => ({
      resizable: true,
      suppressMovable: false,
    }),
    []
  );

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Sl.No",
        valueGetter: (params) => {
          const currentPage = params.api.paginationGetCurrentPage();
          const pageSize = params.api.paginationGetPageSize();
          const rowIndex = params.node.rowIndex;
          return currentPage * pageSize + rowIndex + 1;
        },
        width: 75,
        suppressSizeToFit: true,
      },
      {
        headerName: "Market Name",
        field: "marketname",
        filter: CustomCheckboxFilter,
        width: 170,
      },
      {
        headerName: "Name",
        field: "name",
        filter: CustomCheckboxFilter,
        width: 150,
      },
      {
        headerName: "Draw Date",
        field: "matchDate",
        filter: CustomCheckboxFilter,
        width: 140,
      },
      {
        headerName: "Bet Type",
        field: "bettype",
        filter: CustomCheckboxFilter,
        flex: 1,
        minWidth: 200,
        tooltipField: "bettype",
        cellStyle: {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        },
      },
      {
        headerName: "Status",
        field: "status",
        cellRenderer: MatchToggleButton,
        filter: CustomCheckboxFilter,
        cellRendererParams: {
          refreshList: getMatches,
        },
        width: 110,
        suppressSizeToFit: true,
      },
      {
        headerName: "Actions",
        field: "actions",
        cellRenderer: MatchCustomButton,
        cellRendererParams: {
          isMatch: true,
        },
        suppressMenu: true,
        sortable: false,
        filter: false,
        width: 310,
        suppressSizeToFit: true,
        headerClass: "text-center",
      },
    ],
    []
  );

  return (
    <>
      <div className="mb-4">
        <SearchFilter
          value={quickFilterText}
          onChange={handleQuickFilterChange}
        />
      </div>

      <div
        className="ag-theme-alpine matches-table-container"
        style={{ height: 750, width: "100%" }}
      >
        <AgGridReact
          quickFilterText={quickFilterText}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          autoSizeStrategy={autoSizeStrategy}
          pagination={true}
          paginationPageSize={20}
          rowHeight={52}
          context={{ onEdit, onDelete,onAbandon, onJodiReport }}
          enableCellTextSelection={true}
          tooltipShowDelay={300}
          overlayNoRowsTemplate="<span style='padding: 10px; display: block;'>No data found</span>"
          onFilterChanged={(params) => {
            const rowCount = params.api.getDisplayedRowCount();
            if (rowCount === 0) {
              params.api.showNoRowsOverlay();
            } else {
              params.api.hideOverlay();
            }
          }}
        />
      </div>
    </>
  );
};

export default MatchTable;
